import { Alert, styled } from '@mui/material';
import Box from '@mui/material/Box';
import { useFormikContext } from 'formik';
import React, { memo, useEffect, useMemo } from 'react';

import { ResourceManagerRule, RuleConsequenceCreateObject } from '../../../backend';
import { ResourceNameField } from './ResourceNameField';
import { ScoreField } from './ScoreField';

const StyledDefaultConsequenceBox = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
`;
export const DefaultConsequence = memo(function DefaultConsequence() {
    const { values, setValues } = useFormikContext<ResourceManagerRule>();
    const variable = useMemo(() => values.conditions.conditionOnObjects[0].variableName, [values]);
    const ruleName = useMemo(() => values.name, [values]);

    //set the rule name and the variable name inside the ResourceScore object
    useEffect(() => {
        setValues(o => ({
            ...o,
            consequence: {
                ...o.consequence,
                objectFields: {
                    ...(o.consequence as RuleConsequenceCreateObject).objectFields,
                    flight: {
                        ...(o.consequence as RuleConsequenceCreateObject).objectFields.flight,
                        variable,
                    },
                    rule: {
                        ...(o.consequence as RuleConsequenceCreateObject).objectFields.rule,
                        value: ruleName,
                    },
                },
            },
        }));
    }, [setValues, variable, ruleName]);

    if (!values.conditions?.conditionOnObjects?.[0]?.objectType) {
        return <Alert severity="warning">You must select an object type to create a consequence.</Alert>;
    }

    return (
        <StyledDefaultConsequenceBox>
            <ResourceNameField />
            <ScoreField />
        </StyledDefaultConsequenceBox>
    );
});
